import React, { Component, Fragment } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import Moment from "moment";
import * as myConstList from "../../../BaseUrl";
const baseUrl = myConstList.baseUrl;

class Participant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      participant: [],
      contestCreateType: "",
      predictionOrder: [],
    };

    // this.getData = this.getData.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.participant) {
      this.setState({
        participant: nextProps.participant,
      });
    }
    if (nextProps.contestCreateType) {
      this.setState({
        contestCreateType: nextProps.contestCreateType,
      });
    }
    if (nextProps.predictionOrder) {
      this.setState({
        predictionOrder: nextProps.predictionOrder,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.auth !== undefined &&
      nextProps.auth.user !== undefined &&
      nextProps.auth.user.data !== undefined &&
      nextProps.auth.user.data.message !== undefined &&
      nextProps.auth.user.data.success
    ) {
      this.setState({
        message: nextProps.auth.user.data.message,
      });
    }
    // this.getData()
  }

  showChatHtml = () => {
    let arrData = this.state.participant;
    if (
      this.state.contestCreateType === "coin" ||
      this.state.contestCreateType === "price"
    ) {
      arrData = this.state.predictionOrder;
    }
    // console.log("this.state.participant===",this.state.predictionOrder);
    function redactEmail(email) {
      const atIndex = email.indexOf("@");
      if (atIndex !== -1) {
        const domainIndex = email.indexOf(".", atIndex);
        const domain = email.slice(domainIndex);
        const username = email.slice(0, Math.min(3, atIndex));
        const redactedUsername = "*".repeat(atIndex - 3);
        return `${username}${redactedUsername}@${domain}`;
      } else {
        return email;
      }
    }
    const html = [];
    var collectThis = this;
    if (arrData != undefined && arrData.length > 0) {
      arrData.map(function (value, i) {
        html.push(
          <>
            <tr key={{ i }}>
              <td className="align-middle col-3">{i + 1}</td>
              <td className="col-3">
                {value.name != "null" ? value.name : ""}
              </td>
              <td className="col-3">
                {value.mobile !== ""
                  ? redactEmail(value.email)
                  : value.mobile.replace(/\d(?=\d{4})/g, "*")}
              </td>
              {collectThis.state.contestCreateType !== "price" &&
                collectThis.state.contestCreateType !== "coin" &&
                collectThis.state.contestCreateType !== "forcasting" && (
                  <>
                    <td className="col-3">{value.portfoliovalue.toFixed(2)}</td>
                    <td className="col-3">{value.per.toFixed(3) + "%"}</td>
                    <td className="col-3">{value.order_count}</td>
                  </>
                )}
              {collectThis.state.contestCreateType === "coin" && (
                <>
                  <td>
                    <span className="pr-2">{value.marketPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.predictionPrice}</span>
                  </td>
                </>
              )}

              {collectThis.state.contestCreateType === "price" && (
                <>
                  <td>
                    <span className="pr-2">{value.predictionPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.lastMarketPrice}</span>
                  </td>
                  <td>
                    <span className="pr-2">{value.bidType}</span>
                  </td>
                </>
              )}
              {/* <td className="tr"><b className="crypt-down">-5.4%</b> </td> */}
            </tr>
          </>
        );
      });
    }
    return html;
  };
  componentDidMount() {
    // this.getData()
  }

  // getData() {
  //     axios
  //         .post(baseUrl+"api/user-data")
  //         .then(res => {
  //             this.setState({ records: res.data.data})
  //         })
  //         .catch()
  // }

  render() {
    return (
      <div className="table-responsive">
        <div className="table-responsive winners_table">
          <table className="table  mb-0">
            <tr>
              <th className="th">S.No.</th>
              <th className="th">User Name</th>
              <th className="th">Mobile No/Email ID</th>
              {this.state.contestCreateType !== "price" &&
                this.state.contestCreateType !== "coin" &&
                this.state.contestCreateType !== "forcasting" && (
                  <>
                    <th className="th">Portfolio Value</th>
                    <th className="th">Gain %</th>
                    <th className="th">No of Transactions</th>
                  </>
                )}
              {this.state.contestCreateType === "coin" && (
                <>
                  <th className="th">Coin price</th>
                  <th className="th">Your Bid</th>
                </>
              )}
              {this.state.contestCreateType === "price" && (
                <>
                  <th className="th">Bid Price</th>
                  <th className="th">Closing Price</th>
                  <th className="th">Your Trend</th>
                </>
              )}
            </tr>
            <tbody>{this.showChatHtml()}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

Participant.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  records: state.records,
});
export default connect(mapStateToProps)(Participant);
